<template>
  <Toast position="bottom-right" group="br" />
  <router-view/>
</template>

